"use client";

import { c as _c } from "react/compiler-runtime";
import { Avatar as HeroAvatar } from "@heroui/react";
import { cn } from "../../lib/utils";
import { getAvatarColorClasses, getAvatarInitials } from "./Avatar.utils";
export const Avatar = t0 => {
  const $ = _c(13);
  let className;
  let name;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      name,
      showFallback: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = name;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    name = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showFallback = t1 === undefined ? true : t1;
  let t2;
  if ($[5] !== name) {
    t2 = name ? getAvatarInitials(name) : undefined;
    $[5] = name;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const initials = t2;
  let t3;
  if ($[7] !== className || $[8] !== initials || $[9] !== name || $[10] !== props || $[11] !== showFallback) {
    const colors = name ? getAvatarColorClasses(name) : undefined;
    t3 = <HeroAvatar {...props} name={initials} getInitials={_temp} showFallback={showFallback} className={cn(colors?.bg, colors?.text, className)} />;
    $[7] = className;
    $[8] = initials;
    $[9] = name;
    $[10] = props;
    $[11] = showFallback;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
function _temp(n) {
  return n;
}